function getSortedKeysDeep(record: Record<never, never>): string[] {
    const allKeys = new Set<string>();
    JSON.stringify(record, (key, value) => {
        allKeys.add(key);
        return value;
    });
    return Array.from(allKeys).sort();
}

/**
 * Creates a stable, order-independent cache key from an object by stringifying
 * it with deeply-sorted keys. Two objects with the same entries in a different
 * order (at any nesting level) produce the same key.
 *
 * @param {Record<never, never>} object - The object to hash
 * @returns {string} A deterministic cache key
 */
export function createCacheKey(object: Record<never, never>): string {
    return JSON.stringify(object, getSortedKeysDeep(object));
}
